import * as React from 'react';

import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { type Row } from '@process-advisor/process-miner/api/methods/filters/setStepFilterSelectedGridData';
import { DataGrid } from '@process-advisor/process-miner/eventLog/eventLogDataGrid';

export const EventLogGrid: React.FC = () => {
    const [data, setData] = React.useState<Row[]>([]);
    const [columns, setColumns] = React.useState(null);

    React.useEffect(() => {
        setColumns(apiProvider.processEventLogHeaderUpload());
        setData(apiProvider.processEventLogUpload());
    });
    let rows = []
    if (data) { rows = data.map((row, id) => ({ id, ...row })); }
    return (
        <DataGrid
            rows={rows}
            columns={columns}
            height="300px" />
    );
};
